const Warning = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="24"
            fill="none"
            viewBox="0 0 28 24"
            {...props}
        >
            <path
                fill="#000"
                d="M26.187 24H1.474A1.333 1.333 0 01.32 22L12.675.664a1.333 1.333 0 012.307 0L27.34 22a1.333 1.333 0 01-1.153 2h.001zM13.831 3.536L3.268 21.768H24.38L13.83 3.536zM15.158 16h-2.667V9.332h2.667V16z"
            />
            <path fill="#000" d="M12.498 17.335h2.667v2.667h-2.667v-2.667z" />
        </svg>
    )
}

export default Warning
